export default __webpack_public_path__ + "static/media/arrowup.67c98747.svg";